module.exports = __webpack_public_path__ + "img/img0.20484f8c.jpg";